import { Popper, Paper, Button, Box, PopperProps, styled } from '@mui/material';
import { StyledComponent } from '@emotion/styled';

const zIndex = 2000;

const NotificationsButtonStyled = styled(Button)(({ theme, color }) => {
  const themePalette = color == 'info' ? theme.palette.info : theme.palette.error;
  return {
    position: 'fixed',
    right: 0,
    background: themePalette.dark,
    padding: 0,
    minWidth: 30,
    '&:hover': {
      background: themePalette.main,
      color: themePalette.dark
    },
    '& > div': {
      padding: `${theme.spacing(1.5)} ${theme.spacing(0.5)}`,
      '& > span': {
        fontWeight: 'bold',
        color: 'white',
        padding: `${theme.spacing(1.3)} ${theme.spacing(2)}`
      }
    },
    zIndex
  };
});

const NotificationsPopper: StyledComponent<PopperProps> = styled(Popper)(() => ({
  zIndex
}));

const NotificationsPaper = styled(Paper)(() => ({
  width: 400
}));

const NotificationsContainer = styled(Box)(({ theme }) => ({
  maxHeight: 'calc(100vh - 280px)',
  overflowY: 'auto',
  paddingBottom: `${theme.spacing(1.5)}`
}));

export {
  NotificationsButtonStyled,
  NotificationsPopper,
  NotificationsPaper,
  NotificationsContainer
};
